export default "__VITE_ASSET__C4EEnh9i__";